import { ModuleWithProviders, NgModule } from '@angular/core';
import { provideTransloco, TRANSLOCO_LOADER, translocoConfig } from '@ngneat/transloco';
import { TranslocoHttpLoader } from './transloco.loader';
import { AvailableLanguages } from '@rx-applications/shared/utils';

@NgModule({})
export class TranslocoRootModule {
  static forRoot(config: { supportedLanguages: string[]; isProduction: boolean }): ModuleWithProviders<TranslocoRootModule> {
    return {
      ngModule: TranslocoRootModule,
      providers: [
        provideTransloco({
          config: translocoConfig({
            availableLangs: config.supportedLanguages,
            defaultLang: AvailableLanguages.en_GB,
            reRenderOnLangChange: true,
            prodMode: config.isProduction,
            failedRetries: 1,
            fallbackLang: AvailableLanguages.en_GB,
            missingHandler: {
              allowEmpty: true,
              useFallbackTranslation: true,
              logMissingKey: false,
            },
          }),
        }),
        { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader },
      ],
    };
  }
}
